import { ENTITY_LABELS } from "../../utils/labelMapping";

function getOverviewConfig() {
  return [
    {
      name: `${ENTITY_LABELS.brand} Description, Snippets and Themes`,
      selector: "div[class*='BrandInsights_brand__']",
      id: "snippet_theme",
      is_active: true,
      is_xpath: false,
    },
    {
      name: ENTITY_LABELS.brandIndexScore,
      selector: "div[class*='BrandScore_brand_index_wrapper_']",
      id: "brand_index_score",
      is_active: true,
      is_xpath: false,
    },
    // {
    //   name: "Secondary Category Brand Index Score",
    //   selector: "#secondary_id",
    //   id: "sec_category_brand_index_score",
    //   is_active: true,
    //   is_xpath: false,
    // },
    {
      name: `${ENTITY_LABELS.rank} Details`,
      selector: "#reach_id",
      id: "reach_details",
      is_active: true,
    },
    {
      name: "Sentiment Details",
      selector: "#sentiment_id",
      id: "sentiment_details",
      is_active: true,
    },
    {
      name: "Positive Sentiment Examples",
      selector: 'img[alt="5"], img[alt="4"]',
      id: "positive_sentiment_examples",
      is_active: true,
    },
    {
      name: "Negative Sentiment Examples",
      selector: 'img[alt="1"], img[alt="2"]',
      id: "negative_sentiment_examples",
      is_active: true,
    },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "div[class*='CoreAttributes_card_']",
      id: "brand_pillars",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector: "#print-pdf",
      id: "brand_pillars_details",
      is_active: true,
      is_xpath: false,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "div[class*='CategoryDims_card_']",
      id: "purchase_criteria",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "purchase_criteria_details",
      is_active: true,
      is_xpath: false,
    },
    {
      name: "Positive and Negative Attributes",
      selector: ".MuiBox-root:has(> div[class*='MuiGrid-container'])",
      id: "positivenegative_attributes",
      is_active: true,
      is_xpath: false,
      generate_summary: true,
    },
  ];
}

function getCategoryConfig() {
  return [
    {
      name: "RBI",
      // selector: "#rbi_id",
      selector: "#rbi_pc",
      id: "category_brand_index_score",
      is_active: true,
      // show_change: true,
    },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "#bra_id",
      id: "category_brand_pillars",
      is_active: true,
      // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "category_purchase_criteria",
      is_active: true,
      // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector:
        "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
      id: "category_brand_pillars_details",
      is_active: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "category_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "category_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "category_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

function getCompetitionConfig() {
  return [
    {
      name: "RBI",
      selector: "#primary_id",
      id: "competition_brand_index_score",
      is_active: true,
      // show_change: true,
    },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "#brand_pillars_id",
      id: "competition_brand_pillars",
      is_active: true,
      is_xpath: false,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#purchase_criteria_id",
      id: "competition_purchase_criteria",
      is_active: true,
      is_xpath: false,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector:
        "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
      id: "competition_brand_pillars_details",
      is_active: true,
    },
    {
     name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "competition_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "competition_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "competition_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

function getLlmConfig() {
  return [
    {
      name: "RBI",
      // selector: "#rbi_id",
      selector: "#rbi_pc",
      id: "llm_brand_index_score",
      is_active: true,
      // show_change: true,
    },
    // {
    //   name: "Reach",
    //   selector: "#rank_id",
    //   id: "llm_reach",
    //   is_active: true,
    //   show_change: true,
    // },
    // {
    //   name: "Sentiment",
    //   selector: "#fav_id",
    //   id: "llm_sentiment",
    //   is_active: true,
    //   show_change: true,
    // },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "#bra_id",
      id: "llm_brand_pillars",
      is_active: true,
      // show_change: true,
    },
    {
      name: ENTITY_LABELS.purchaseCriteria, // ✅ fresh on every call
      selector: "#pur_id",
      id: "llm_purchase_criteria",
      is_active: true,
      // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector:
        "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
      id: "llm_brand_pillars_details",
      is_active: true,
    },
    {
     name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "llm_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "llm_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "llm_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

function getMarketConfig() {
  return [
    {
      name: "RBI",
      // selector: "#rbi_id",
      selector: "#rbi_pc",
      id: "market_brand_index_score",
      is_active: true,
      // show_change: true,
    },
    // {
    //   name: "Reach",
    //   selector: "#rank_id",
    //   id: "market_reach",
    //   is_active: true,
    //   show_change: true,
    // },
    // {
    //   name: "Sentiment",
    //   selector: "#fav_id",
    //   id: "market_sentiment",
    //   is_active: true,
    //   show_change: true,
    // },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "#bra_id",
      id: "market_brand_pillars",
      is_active: true,
      // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "market_purchase_criteria",
      is_active: true,
      // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector:
        "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
      id: "market_brand_pillars_details",
      is_active: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "market_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "market_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "market_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

function getPersonaConfig() {
  return [
    {
      name: "RBI",
      // selector: "#rbi_id",
      selector: "#rbi_pc",
      id: "persona_brand_index_score",
      is_active: true,
      // show_change: true,
    },
    // {
    //   name: "Reach",
    //   selector: "#rank_id",
    //   id: "persona_reach",
    //   is_active: true,
    //   show_change: true,
    // },
    // {
    //   name: "Sentiment",
    //   selector: "#fav_id",
    //   id: "persona_sentiment",
    //   is_active: true,
    //   show_change: true,
    // },
    {
    name: ENTITY_LABELS.brandPillar,
      selector: "#bra_id",
      id: "persona_brand_pillars",
      is_active: true,
      // show_change: true,
    },
    {
    name: ENTITY_LABELS.purchaseCriteria,
      selector: "#pur_id",
      id: "persona_purchase_criteria",
      is_active: true,
      // show_change: true,
    },
    {
      name: `${ENTITY_LABELS.brandPillar} Details`,
      selector:
        "div:has(> span > span[aria-label*='Eight predefined categories']) > button",
      id: "persona_brand_pillars_details",
      is_active: true,
    },
    {
      name: `${ENTITY_LABELS.purchaseCriteria} Details`,
      selector: "#print-pdf",
      id: "persona_purchase_criteria_details",
      is_active: true,
    },
    {
      name: "Positive Attributes",
      selector: "//h6[text()='Positive Attributes']/parent::div",
      id: "persona_positive_attributes",
      is_active: true,
      is_xpath: true,
    },
    {
      name: "Negative Attributes",
      selector: "//h6[text()='Negative Attributes']/parent::div",
      id: "persona_negative_attributes",
      is_active: true,
      is_xpath: true,
    },
  ];
}

// ─── no ENTITY_LABELS — safe at module level ──────────────────────────────────
function getSourceConfig() {
  return [
  {
    name: `${ENTITY_LABELS.brand} Query Sources`,
    selector: "#brand_id",
    id: "source_brand_source",
    is_active: true,
    is_xpath: false,
  },
  {
    name: "Category Query Sources",
    selector: "#category_id",
    id: "source_category_source",
    is_active: true,
    is_xpath: false,
  },
]
}

const actionConfig = [
  {
    id: "actions_table",       // 👈 id for the table container
    name: "Actions Table",
    selector: "#FocusArea",    // Puppeteer will screenshot this element
    is_active: true,
    is_xpath: false,
  },
];

// ─── MAIN EXPORT ──────────────────────────────────────────────────────────────
export function getInitialBrandTabs() {
  return [
    { id: "overview", label: "Overview", config: getOverviewConfig() },
    { id: "category", label: "Category", config: getCategoryConfig() },
    { id: "competition", label: "Competition", config: getCompetitionConfig() },
    { id: "llm", label: "LLM", config: getLlmConfig() },
    { id: "market", label: "Market", config: getMarketConfig() },
    { id: "persona", label: "Personas", config: getPersonaConfig() },
    { id: "source", label: "Sources", config: getSourceConfig() },
    { id: "actions", label: "Actions", config: actionConfig },
  ];
}